import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from "@angular/core";
import { UserAvatarComponent } from "../../../../shared/components/user-avatar/user-avatar.component";
import { FlagComponent } from "../../../../shared/components/flag/flag.component";

@Component({
  selector: "app-chat-header",
  standalone: true,
  imports: [UserAvatarComponent, FlagComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./chat-header.component.html",
  styleUrl: "./chat-header.component.scss",
})
export class ChatHeaderComponent {
  readonly name = input<string>("");
  readonly avatarUrl = input<string | null>(null);
  readonly country = input<string>("");
  readonly blockConfirmation = input<boolean>(false);
  readonly sharedInterests = input<string[]>([]);

  readonly block = output<void>();
  readonly cancelBlock = output<void>();

  countryName(code: string): string {
    if (!code || code.length !== 2) return "";
    try {
      return (
        new Intl.DisplayNames(["en"], { type: "region" }).of(
          code.toUpperCase(),
        ) ?? code
      );
    } catch {
      return code;
    }
  }
}
